<template>

  <v-dialog v-model="intDialogVisible" max-width="90%" class="addValueModal addComment">
    <ConfirmModal :dialogVisible='showConfirmDelete' @close="showConfirmDelete = false" @confirmed="deleteFileReald($event)" title="Delete this document?"  message="It will not be used for any future requests by other users from your company." ></ConfirmModal>

    <v-card>

      <v-card-title class="flexhe">
        <div class="rititle">
          <h3 class="primary--text formName">DATA ROOM<span class="counter_indicator">{{dataroom_size}}</span></h3>
          Keep your insights updated for relevant results
        </div>


        <v-btn class="closeBTTN" @click="finish" >
          <img :src="require('@/assets/croix.svg')" alt=""/>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="dataroom_lists">


      <div class="one_dataroom">
          <h2 class="dataroom_title">1. Market and business intelligence</h2>
          <div class="dataroom_files">
              <div class="dataroom_uploader_container">
                <DataroomUploader filetype="makert_and_business_intelligence" @fileAdded="reloadDataRoom"/>
              </div>
              <div class="one_file" v-for="(file ,fk) in makert_and_business_intelligence_files" :key="fk">
                <div class="file_info">
                    <div class="filename">{{file.original_file_name.split('.').slice(0, -1).join('.')}}</div>
                    <div class="file_credit">
                        <div class="">
                            UPLOADED : <span class="vale">{{file.formatted_date}}</span>
                        </div>
                        <div class="">
                            BY : <span class="vale">{{file.user.firstname}} {{file.user.lastname}}</span>
                        </div>
                    </div>
                </div>
                <div class="file_action">
                  <div class="action_dr">
                    <a class="button" :href="apiUrl+'/dr/'+file.file_name" target="_blank"  :download="file.original_file_name">
                      <img :src="require('@/assets/blueDownload.svg')" alt=""/>
                    </a>
                    <a class="button" target="_blank" :href="apiUrl+'/dr/'+file.file_name">
                      <img :src="require('@/assets/eyeInno.svg')" alt=""/>
                    </a>

                    <button type="button" class="button" name="button" @click="deleteFile(file._id)">
                      <img :src="require('@/assets/trashInno.svg')" alt=""/>
                    </button>
                  </div>
                </div>
              </div>

          </div>
      </div>


      <div class="one_dataroom priorities_and_goals">
          <h2 class="dataroom_title">2. Priorities and goals</h2>
          <div class="dataroom_files">
              <div class="dataroom_uploader_container">
                <DataroomUploader filetype="priorities_and_goals" @fileAdded="reloadDataRoom"/>
              </div>
              <div class="one_file" v-for="(file ,fk) in priorities_and_goals_files" :key="fk">
                <div class="file_info">
                    <div class="filename">{{file.original_file_name.split('.').slice(0, -1).join('.')}}</div>
                    <div class="file_credit">
                        <div class="">
                            UPLOADED : <span class="vale">{{file.formatted_date}}</span>
                        </div>
                        <div class="">
                            BY : <span class="vale">{{file.user.firstname}} {{file.user.lastname}}</span>
                        </div>
                    </div>
                </div>
                <div class="file_action">
                  <div class="action_dr">
                    <a class="button" :href="apiUrl+'/dr/'+file.file_name" target="_blank"  :download="file.original_file_name">
                      <img :src="require('@/assets/blueDownload.svg')" alt=""/>
                    </a>
                    <a class="button" target="_blank" :href="apiUrl+'/dr/'+file.file_name">
                      <img :src="require('@/assets/eyeInno.svg')" alt=""/>
                    </a>

                    <button type="button" class="button" name="button" @click="deleteFile(file._id)">
                      <img :src="require('@/assets/trashInno.svg')" alt=""/>
                    </button>
                  </div>
                </div>
              </div>

          </div>
      </div>
              </div>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="addValue" @click="finish" >
                  CLOSE
                </v-btn>
              </v-card-actions>
    </v-card-text>
  </v-card>
</v-dialog>
</template>
<script>
 import api from '../tools/api';
 import DataroomUploader from '@/components/DataroomUploader.vue'
  import ConfirmModal from '@/components/modals/ConfirmModal.vue'
import { toast } from 'vue-sonner'
export default {
  components: {
    DataroomUploader,
    ConfirmModal
  },
  props: {
    dialogVisible: Boolean,
  },
  name: 'DataRoom',
  data() {
    return {
      fid:null,
showConfirmDelete:false,
      pearlAI_reflexion:false,
      apiUrl: process.env.VUE_APP_API_URL,
      backendUrl : 'https://pearl-ai-backend-32scxi5uja-oa.a.run.app/process',

      dataroom_size :0,
      display_debug_topic : false,
      makert_and_business_intelligence_files : [],
      priorities_and_goals_files : []
    }
  },
  methods:{
      reloadDataRoom(){
        console.log("i wil reload dataroom");
        api.get(process.env.VUE_APP_API_URL+"/restrict/get_my_dataroom").then( (r) => {
          this.makert_and_business_intelligence_files = r.data.makert_and_business_intelligence_files
          this.priorities_and_goals_files = r.data.priorities_and_goals_files;
          this.dataroom_size = this.makert_and_business_intelligence_files.length + this.priorities_and_goals_files.length;
          console.log(r);
        }).catch( (e) => {
          console.log(e);
           toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
      },
      finish(){
        var size =  this.makert_and_business_intelligence_files.length + this.priorities_and_goals_files.length;
          this.$emit('endOfDataroomUpload',size);
      },
      deleteFile(fid){
        this.fid = fid;
        this.showConfirmDelete = true;
      },
      closeDeleteModal(){
        this.fid = null;
        this.showConfirmDelete = false;
      },
      deleteFileReald(){
        api.post(process.env.VUE_APP_API_URL+"/restrict/delete_dataroom_file",{
          file:this.fid
        },
        {
          headers: {
              'Content-Type': 'application/json',
          }
        }).then( () => {
          toast.success("File successfully removed from your dataroom");
          this.showConfirmDelete = false;
          this.fid =null;
          this.reloadDataRoom();
        }).catch( (e) => {
          console.log(e);
          this.showConfirmDelete = false;
           toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
      }
  },
  computed: {
    intDialogVisible: {
      get: function () {
        if (this.dialogVisible) {
          // Some dialog initialization code could be placed here
          // because it is called only when this.dialogVisible changes
        }

        return this.dialogVisible
      },
      set: function (value) {
             if (!value) {
                this.$emit('close', value);
             }
      }
    }
  },
  watch: {
    dialogVisible: function(){
        this.reloadDataRoom();
    }
  }
}
</script>
<style scoped>

.where_to_innovate_finder{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}
.title_main{
  text-align: center;
}
.title_main h1{
  font-size:24px;
  color:#3783C5;
  font-weight: 600;
}
.title_main .counter_indicator{
  background:#FED7DF;
  color:#C60932;
  padding:5px 10px;
  font-size:13px;
  border-radius:20px;
  margin-top:-10px;
  vertical-align:text-top;
}


.dataroom_title{
  color:#3783C5;
  font-size:22px;
  font-weight: 500;
  text-transform: uppercase;
}

.dataroom_files{
  display:flex;
  flex-direction: column;
  gap:10px;
}

.one_file{
  width:100%;
  background:#F1F6FB;
  padding:20px;
  border-radius:15px;
  display:flex;
  align-items: center;
}
.one_file .file_info{
  flex:1;
}

.filename{
  color:#04246A;
  font-size:20px;
  width:100%;
}
.file_credit{
  text-transform: uppercase;
  color:#04246A;
  font-size:13px;
  font-weight: 500;
  display:flex;
  gap:20px;
}
.vale{
  color:#3783C5;
}

.action_dr{
    background:#FFF;
    padding:10px 20px;
    border-radius:20px;
    display:flex;
    gap:20px;

}


.dataroom_uploader_container{
  width:100%;
  background:#F1F6FB;
  padding:20px;
  border-radius:15px;
  margin-top:25px;
}

@media screen and (max-width:990px){
  .where_to_innovate_finder{
    padding-left:20px;
    padding-right:20px;
  }
  .one_file{
    flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  }
  .file_credit{
    flex-direction: column;
  align-items: flex-start;
  gap:10px;
  margin-top:10px;
  flex-wrap: wrap;
}
.filename{
  word-break: break-all;
}
.content_div{
  padding-left:20px;
  padding-right: 20px;
}
}

.dataroom_lists{
  display:flex;gap:50px;flex-direction: column;
  margin-bottom:50px;
}

.addValueModal button.addValue{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 7px 18.5px;
  color:#3783C5;
  margin: 5px;
  background:#3783C5;
  color:#fff;
}
.flexhe{
  display:flex;
  justify-content: space-between;
  align-items: center;
  gap:10px;
  position: sticky;
  top: 0;
  background: #FFF;
}
.closeBTTN img{
  width:15px;
  height:15px;
}
.closeBTTN:hover,
.closeBTTN{
  background:transparent !important;
  border:none !important;
  box-shadow: none !important;
}

.rititle h3{
  margin-bottom: 0px;
}
.rititle{
  margin: auto;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  text-align: center;
  padding-top: 10px;
  color:#3783C5;
}

.counter_indicator{
 background:#FED7DF;
 color:#C60932;
 padding:5px 15px;
 font-size:13px;
 margin-left:5px;
 border-radius:20px;
 margin-top:-10px;
 vertical-align:text-top;
}
</style>
